/**
 * @description Simple name regex
 */
export const nameRegex = /^[^~`!@#$%^&*_+=?;[\]{}\\|/]*$/

/* eslint-disable */
/**
 * @description Simple email regex
 * Uses the same regex as Zod's email() method
 * @see https://github.com/colinhacks/zod/blob/207205cab4b4f33f9274a9cce5040d6ced692300/src/types.ts#L599
 */
export const emailRegex = /^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i
/* eslint-enable */
